import { toast } from "react-toastify"
import { getAllWhistleInvitedUsers } from "../../../api/lead/whistleblowing"
import { invitedUsers, invitedUsersResponse } from "../../../utils/types"

export const abs="ss"


export const getAllUsersInvited = async (id:string): Promise<invitedUsers[]> => {
    const response = (await getAllWhistleInvitedUsers(id)) as invitedUsersResponse

    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }
